import { createStore } from 'vuex'
import SharedService from '../services/shared'

export const dataProgress = createStore({
  state: () => {
    return {
      lessons: {},
      modules: {},
      training: null,
      questionResults: {}
    }
  },
  getters: {
    lessonStatusById: (st) => (lessonId) =>
      st.lessons?.[lessonId]?.status || 'not_started',
    moduleStatusById: (st) => (moduleId) =>
      st.modules?.[moduleId]?.status || 'not_started',
    trainingStatus: (st) => st.training?.status || 'not_started',
    trainingProgress: (st) => st.training,
    questionResultsByLesson: (st) => (lessonId) => st.questionResults?.[lessonId] || {},
    lessonSnapshotById: (st) => (lessonId) => st.lessons?.[lessonId] || null,
  },
  mutations: {
    SET_PROGRESS(state, payload) {
      state.lessons = payload.lessons || {}
      state.modules = payload.modules || {}
      state.training = payload.training || null
    },
    MERGE_SNAPSHOT(state, snap) {
      if (snap.lesson?.id) {
        const { id, ...rest } = snap.lesson
        state.lessons = { ...state.lessons, [id]: rest }
      }
      if (snap.module?.id) {
        const { id, ...rest } = snap.module
        state.modules = { ...state.modules, [id]: rest }
      }
      if (snap.training) {
        state.training = { ...(state.training || {}), ...snap.training }
      }
    },
    MARK_QUESTION_RESULT(state, { lessonId, questionId, result }) {
      const map = state.questionResults[lessonId] || {}
      state.questionResults = {
        ...state.questionResults,
        [lessonId]: { ...map, [questionId]: result },
      }
    },
    RESET_LESSON_RESULTS(state, lessonId) {
      const clone = { ...state.questionResults }
      delete clone[lessonId]
      state.questionResults = clone
    },
  },
  actions: {
    async fetchTrainingProgress({ commit }, trainingId) {
      const { data } = await SharedService.getTrainingProgress(trainingId)
      // data esperado: { lessons: {...}, modules: {...}, training: {...} }
      commit('SET_PROGRESS', data || {})
    },
    mergeSnapshot({ commit }, snapshot) {
      commit('MERGE_SNAPSHOT', snapshot)
    },
    markQuestionResult({ commit }, payload) {
      commit('MARK_QUESTION_RESULT', payload)
    },
    resetLessonResults({ commit }, lessonId) {
      commit('RESET_LESSON_RESULTS', lessonId)
    },
  }
})
